import React, { useEffect, useState, createContext, useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BookOpen, Archive, Heart, PieChart, Calendar, ClipboardList, MessageSquare, BoxIcon, Home, Menu, X, Mail, BookOpenCheck, Clock } from 'lucide-react';
// Create a context to share the sidebar state with the Header
export const SidebarContext = createContext({
  isOpen: false,
  setIsOpen: (value: boolean) => {}
});
export const useSidebarContext = () => useContext(SidebarContext);
const menuItems = [{
  icon: Home,
  label: 'ANASAYFA',
  path: '/'
}, {
  icon: BookOpen,
  label: 'KONU ANLATIM',
  path: '/topics'
}, {
  icon: BoxIcon,
  label: 'SORU ÇÖZÜM',
  path: '/questions'
}, {
  icon: Archive,
  label: 'SORU ARŞİVİM',
  path: '/archive'
}, {
  icon: BookOpenCheck,
  label: 'ÖDEVLERİM',
  path: '/homework'
}, {
  icon: Clock,
  label: 'ONLINE DENEMELER',
  path: '/online-denemeler'
}, {
  icon: Heart,
  label: 'REHBERLİK',
  path: '/guidance'
}, {
  icon: Mail,
  label: 'MESAJLARIM',
  path: '/messages'
}, {
  icon: PieChart,
  label: 'SINAV ANALİZLERİ',
  path: '/analysis'
}, {
  icon: Calendar,
  label: 'PROGRAMIM',
  path: '/schedule'
}, {
  icon: ClipboardList,
  label: 'KONU TAKİP ÇİZELGESİ',
  path: '/progress'
}, {
  icon: MessageSquare,
  label: 'FORUM',
  path: '/forum'
}];
export function SidebarProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);
  // Close sidebar when clicking outside
  useEffect(() => {
    const handleOutsideClick = (e: MouseEvent) => {
      // Check if the sidebar is open and the click is outside the sidebar
      if (isOpen) {
        const sidebarElement = document.getElementById('mobile-sidebar');
        if (sidebarElement && !sidebarElement.contains(e.target as Node)) {
          setIsOpen(false);
        }
      }
    };
    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, [isOpen]);
  return <SidebarContext.Provider value={{
    isOpen,
    setIsOpen
  }} data-id="element-1049">
      {children}
    </SidebarContext.Provider>;
}
export function Sidebar() {
  const location = useLocation();
  const {
    isOpen,
    setIsOpen
  } = useSidebarContext();
  return <>
      {/* Sidebar for mobile (slide in from left) */}
      <div className={`md:hidden fixed inset-0 z-40 ${isOpen ? 'block' : 'hidden'}`} data-id="element-1050">
        <div className="absolute inset-0 bg-black/50" onClick={() => setIsOpen(false)} data-id="element-1051"></div>
        <div id="mobile-sidebar" className="absolute top-0 left-0 bottom-0 w-64 max-w-[80%] bg-black overflow-y-auto transform transition-transform duration-300" data-id="element-1052">
          <div className="relative p-[1px] h-full rounded-r-xl overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600 w-full" data-id="element-1053">
            <div className="bg-black/90 rounded-r-xl p-4 w-full h-full" data-id="element-1054">
              <div className="flex justify-end mb-4" data-id="element-1055">
                <button onClick={() => setIsOpen(false)} className="p-2 rounded-full bg-white/10 hover:bg-white/20 transition-colors" data-id="element-1056">
                  <X className="w-5 h-5" data-id="element-1057" />
                </button>
              </div>
              <nav className="space-y-2" data-id="element-1058">
                {menuItems.map(item => <Link key={item.label} to={item.path} onClick={() => setIsOpen(false)} className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${location.pathname === item.path ? 'text-white border border-purple-500 border-opacity-80' : 'text-gray-400 hover:text-white hover:bg-white/5'}`} data-id="element-1059">
                    <item.icon className="w-5 h-5 shrink-0" data-id="element-1060" />
                    <span className="text-sm font-medium whitespace-nowrap" data-id="element-1061">
                      {item.label}
                    </span>
                  </Link>)}
              </nav>
            </div>
          </div>
        </div>
      </div>

      {/* Desktop sidebar (always visible) */}
      <div className="hidden md:block relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600 w-full md:w-64 md:min-w-[250px] shrink-0" data-id="element-1062">
        <aside className="sticky top-4 bg-black/90 rounded-xl p-4 w-full h-full" data-id="element-1063">
          <nav className="space-y-2" data-id="element-1064">
            {menuItems.map(item => <Link key={item.label} to={item.path} className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${location.pathname === item.path ? 'text-white border border-purple-500 border-opacity-80' : 'text-gray-400 hover:text-white hover:bg-white/5'}`} data-id="element-1065">
                <item.icon className="w-5 h-5 shrink-0" data-id="element-1066" />
                <span className="text-sm font-medium whitespace-nowrap" data-id="element-1067">
                  {item.label}
                </span>
              </Link>)}
          </nav>
        </aside>
      </div>
    </>;
}